// Máscara e validação de CPF/CNPJ (PO1-2428). Extraído do padrão duplicado em
// views/Empresa/Embarcadores e EmbarcadorDetalheModal — usar este daqui.

export function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "");
}

export function formatDocument(value) {
  const digits = digitsOnly(value);

  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  if (digits.length === 14) {
    return digits.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      "$1.$2.$3/$4-$5"
    );
  }

  return value || "-";
}

export function formatCep(value) {
  const digits = digitsOnly(value);
  return digits.length === 8
    ? digits.replace(/(\d{5})(\d{3})/, "$1-$2")
    : value || "";
}

// Dígito verificador de CNPJ — não existia validação real no repo.
export function isValidCnpj(value) {
  const cnpj = digitsOnly(value);
  if (cnpj.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  const calcDigit = (base) => {
    let factor = base.length - 7;
    let sum = 0;
    for (let i = 0; i < base.length; i += 1) {
      sum += Number(base[i]) * factor;
      factor -= 1;
      if (factor < 2) factor = 9;
    }
    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
  };

  const d1 = calcDigit(cnpj.slice(0, 12));
  if (d1 !== Number(cnpj[12])) return false;
  const d2 = calcDigit(cnpj.slice(0, 13));
  return d2 === Number(cnpj[13]);
}

// PO1-3066: o destinatário pode ser pessoa física. Nas notas dos últimos 30 dias o documento
// de entrega tem 14 dígitos (CNPJ) em ~75 mil e 11 dígitos (CPF) em ~13 mil.

// Dígito verificador de CPF; todos os dígitos iguais é inválido.
export function isValidCpf(value) {
  const cpf = digitsOnly(value);
  if (cpf.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  const calcDigit = (base) => {
    let sum = 0;
    for (let i = 0; i < base.length; i += 1) {
      sum += Number(base[i]) * (base.length + 1 - i);
    }
    const rest = (sum * 10) % 11;
    return rest === 10 ? 0 : rest;
  };

  const d1 = calcDigit(cpf.slice(0, 9));
  if (d1 !== Number(cpf[9])) return false;
  const d2 = calcDigit(cpf.slice(0, 10));
  return d2 === Number(cpf[10]);
}

// CPF (11 dígitos) ou CNPJ (14 dígitos) com dígito verificador; qualquer outro tamanho é inválido.
export function isValidDocumento(value) {
  const digits = digitsOnly(value);
  if (digits.length === 11) return isValidCpf(digits);
  if (digits.length === 14) return isValidCnpj(digits);
  return false;
}

// Máscara progressiva enquanto digita: até 11 dígitos exibe a de CPF (000.000.000-00),
// de 12 a 14 a de CNPJ (00.000.000/0000-00). Descarta o que passar de 14 dígitos.
export function mascaraDocumentoParcial(value) {
  const d = digitsOnly(value).slice(0, 14);
  if (d.length <= 11) {
    if (d.length > 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
    if (d.length > 6) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
    if (d.length > 3) return `${d.slice(0, 3)}.${d.slice(3)}`;
    return d;
  }
  if (d.length > 12) {
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
  }
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
}
